import { UserSettingsModel } from '../../../../types/UserSettings';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareSetUserSettingsEnabled = ({
    setting,
    isEnabled,
}: {
    setting: UserSettingsModel;
    isEnabled: boolean;
}) =>
    setting.prepareUpdate((userSetting) => {
        userSetting.enabled = isEnabled;
    });

export const logSetUserSettingsEnabledAction = ({
    setting,
    logDBAction,
    tableName,
}: {
    setting: UserSettingsModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'UserSettings enable',
        modelName: tableName,
        payload: setting,
    });
};
